module.exports = __webpack_public_path__ + "img/ic_digital_tools.a8bb8563.png";